var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.362)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    fillRule: "evenodd",
    d: "m 3.99972,1030.3621 0,-4.4044 c 0,-0.884 0.71166,-1.5956 1.59566,-1.5956 l 19.80868,0 c 0.884,0 1.59566,0.7116 1.59566,1.5956 l 0,4.4044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#12aef5",
    fillRule: "evenodd",
    d: "m 4.77833,1028.3621 21.44831,0 c 0.96086,0 2.0068,0.8129 1.73441,1.7344 l -2,6.7656 2,8.7656 c 0.21372,0.9367 -0.77355,1.7344 -1.73441,1.7344 l -21.44831,0 c -0.96087,0 -1.94813,-0.7977 -1.73442,-1.7344 l 2,-8.7656 -2,-6.7656 c -0.2724,-0.9215 0.77355,-1.7344 1.73442,-1.7344 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4788f4",
    fillRule: "evenodd",
    d: "m 4.77833,1028.3621 21.44831,0 c 0.96086,0 2.00682,0.8129 1.73441,1.7344 l -2,6.7656 -20.91714,0 -2,-6.7656 c -0.27241,-0.9215 0.77355,-1.7344 1.73442,-1.7344 z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 14.632812,1030.9141 c -1.7698,-0.3153 -3.491765,0.7962 -3.955078,2.5429 a 0.50005,0.50005 0 1 0 0.966797,0.2559 c 0.33381,-1.2585 1.549143,-2.0375 2.8125,-1.8125 1.263369,0.225 2.145677,1.3813 2.033203,2.6797 -0.112436,1.2983 -1.178325,2.2812 -2.460937,2.2812 a 0.50005,0.50005 0 1 0 0,1 c 1.797344,0 3.301066,-1.3943 3.457031,-3.1953 0.156016,-1.801 -1.083699,-3.4367 -2.853516,-3.7519 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#f9f9f9",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.5,1036.8613 a 0.50004997,0.50004997 0 1 0 0,1 c 1.214761,0 2.306571,0.7311 2.771484,1.8535 0.46491,1.1225 0.208622,2.4105 -0.65039,3.2696 -0.85899,0.8591 -2.147211,1.1153 -3.269532,0.6504 -1.122336,-0.465 -1.851587,-1.5565 -1.851562,-2.7715 a 0.50004997,0.50004997 0 1 0 -1,0 c -3.38e-5,1.6165 0.975366,3.0767 2.46875,3.6953 1.493364,0.6186 3.216434,0.2759 4.359375,-0.8672 1.142971,-1.1431 1.485761,-2.8659 0.867187,-4.3594 -0.618579,-1.4934 -2.078927,-2.4707 -3.695312,-2.4707 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#f9f9f9",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.992188,1030.8613 A 0.50005,0.50005 0 0 0 20.5,1031.3691 l 0,13 a 0.50005,0.50005 0 1 0 1,0 l 0,-13 a 0.50005,0.50005 0 0 0 -0.507812,-0.5078 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#f9f9f9",
    fillRule: "evenodd",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21.015625,1030.8574 a 0.50005,0.50005 0 0 0 -0.181641,0.027 l -2.986328,1 a 0.50058309,0.50058309 0 1 0 0.31836,0.9492 l 2.986328,-1 a 0.50005,0.50005 0 0 0 -0.136719,-0.9766 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#f9f9f9",
    fillRule: "evenodd",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M11.49971 1026.3621a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5zM20.49971 1026.3621a.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 01.5.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.1765dbc9.svg";
export { ForwardRef as ReactComponent };